import { 
  GET_DATA_STORAGE,
  GET_DATA_FILE,
  LOGOUT
} from '../action';

const initialState = {
  
  isGettingDataStorage: false,
  isGottenDataStorageSuccess: false,
  isGottenDataStorageNotFound: false,
  isGottenDataStorageFail: false,

  dataStorage: [],

  isGettingDataFile: false,
  isGottenDataFileSuccess: false,
  isGottenDataFileNotFound: false,
  isGottenDataFileFail: false,

  xdataFile: [],
  ydataFile: [],
  
};

export default (state = initialState, action) => {
  switch (action.type) {
    
    case GET_DATA_STORAGE.REQUEST:
      return {
        ...state,
        isGettingDataStorage: true,
        isGottenDataStorageSuccess: false,
        isGottenDataStorageNotFound: false,
        isGottenDataStorageFail: false,
        dataStorage: []
      };
    case GET_DATA_STORAGE.SUCCESS:
      return {
        ...state,
        isGettingDataStorage: false,
        isGottenDataStorageSuccess: true,
        isGottenDataStorageNotFound: false,
        isGottenDataStorageFail: false,
        dataStorage: [...action.data]
      };
    case GET_DATA_STORAGE.FAIL:
      return {
        ...state,
        isGettingDataStorage: false,
        isGottenDataStorageSuccess: false,
        isGottenDataStorageNotFound: action.data.isNotFound,
        isGottenDataStorageFail: action.data.isFail,
      };
    
    case GET_DATA_FILE.REQUEST:
      return {
        ...state,
        isGettingDataFile: true,
        isGottenDataFileSuccess: false,
        isGottenDataFileNotFound: false,
        isGottenDataFileFail: false,
      };

    case GET_DATA_FILE.SUCCESS:
      return {
        ...state,
        isGettingDataFile: false,
        isGottenDataFileSuccess: true,
        isGottenDataFileNotFound: false,
        isGottenDataFileFail: false,
        xdataFile: [...action.data.xdata],
        ydataFile: [...action.data.ydata],
      };

    case GET_DATA_FILE.FAIL:
      return {
        ...state,
        isGettingDataFile: false,
        isGottenDataFileSuccess: false,
        isGottenDataFileNotFound: action.data.isNotFound,
        isGottenDataFileFail: action.data.isFail,
      };
    
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
